export default "__VITE_ASSET__DKLtN$hH__"